import axios from 'axios';
import { clearAuth } from './utils/auth';

const PUBLIC_ENDPOINTS = [
    '/auth/login',
    '/auth/register',
    '/auth/verify-whatsapp',
    '/auth/resend-otp',
    '/auth/forgot-password',
    '/auth/reset-password',

    '/blogs',
    '/legal-documents',
    '/legal-documents/privacy-policy',
    '/legal-documents/terms-and-conditions',
];

const PUBLIC_PAGES = ['/login', '/register', '/verify-otp', '/forgot-password', '/reset-password'];

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-Platform': process.env.REACT_APP_PLATFORM,
        'X-API-Key': process.env.REACT_APP_API_KEY,
    },
});

const isPublicEndpoint = (url = '') => PUBLIC_ENDPOINTS.some((endpoint) => url.includes(endpoint));

const isPublicPage = () => PUBLIC_PAGES.some((page) => window.location.pathname.startsWith(page));

const extractApiMessage = (error) => {
    const data = error?.response?.data;

    return (
        data?.message ||
        data?.error ||
        (Array.isArray(data?.errors) ? data.errors[0] : Object.values(data?.errors || {}).flat?.()?.[0]) ||
        error?.message ||
        'Terjadi kesalahan. Silakan coba lagi.'
    );
};

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('mp_token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const requestUrl = error.config?.url || '';
        const skipAuthRedirect = error.config?.skipAuthRedirect === true;

        if (status === 401 && !skipAuthRedirect && !isPublicEndpoint(requestUrl) && !isPublicPage()) {
            clearAuth();
            window.location.replace('/login?session=expired');
        }

        error.apiMessage = extractApiMessage(error);

        return Promise.reject(error);
    }
);

export default axiosInstance;
